module.exports = __webpack_public_path__ + "img/otopack150-active.d0e5dc26.svg";